const $input = $('input, textarea');

$input.on('focus', function () {
  $(this).closest('.gfield').find('label').addClass('away');

  console.log($(this).attr('type'));
  console.log($(this).val().length);
});

$input.on('blur', function () {
  if (!$(this).val()) {
    $(this).closest('.gfield').find('label').removeClass('away');
  }
});

$('input[type="file"]').on('focus', function () {
  $(this).closest('.gfield').find('label').addClass('focus');
});
$('input[type="file"]').on('blur', function () {
  $(this).closest('.gfield').find('label').removeClass('focus');
});

$('footer .gfield--type-html').on('click', ()=> {
  $('.gform_footer .gform_button').click()
});

$(document).on('select2:open', 'select', function() {
  $('.select2-search--dropdown .select2-search__field').attr('placeholder', 'Type to search…');
});

/**
 * Footer newsletter: disable Subscribe until the email field has a value.
 * Only targets forms inside <footer> so contact/other GF forms stay submittable.
 */
function syncFooterNewsletterSubmit(form) {
  const $form = form
    ? $(form).filter(function () {
        return $(this).closest('footer').length > 0;
      })
    : $('footer .gform_wrapper form');

  $form.each(function () {
    const $email = $(this).find('input[type="email"]').first();
    const $button = $(this).find(
      'button[type="submit"], input[type="submit"], .gform-button[type="submit"], .gform_button'
    ).first();
    if (!$email.length || !$button.length) {
      return;
    }

    const hasValue = String($email.val() || '').trim().length > 0;
    $button.prop('disabled', !hasValue).attr('aria-disabled', hasValue ? 'false' : 'true');
  });
}

/**
 * Keep footer validation compact: short message above the email field.
 */
function simplifyFooterNewsletterErrors(formId) {
  const $wrapper = formId
    ? $(`#gform_wrapper_${formId}`).filter(function () {
        return $(this).closest('footer').length > 0;
      })
    : $('footer .gform_wrapper');

  $wrapper.each(function () {
    $(this)
      .find('.gfield--type-email .gfield_validation_message, .gfield--type-email .validation_message')
      .text('Enter a valid email');
  });
}

$(document).on('input change keyup', 'footer .gform_wrapper input[type="email"]', function () {
  syncFooterNewsletterSubmit($(this).closest('form'));
});

$(document).on('gform_post_render', function (_event, formId) {
  syncFooterNewsletterSubmit($(`#gform_${formId}`));
  simplifyFooterNewsletterErrors(formId);
});

syncFooterNewsletterSubmit();
simplifyFooterNewsletterErrors();
